export default __webpack_public_path__ + "static/media/mapExample.d25143cd.png";